// extracted by mini-css-extract-plugin
export default {"delete":"EditProductAction_delete__-53zj"};